import React, {useMemo, ReactNode} from 'react'
import useActiveWeb3React from './hooks/useActiveWeb3React'
import {BLOCKED_ADDRESSES} from './config/constants'
import MulticallUpdater from './state/multicall/updater'
import TransactionUpdater from './state/transactions/updater'
import App from './App'
import Providers from './Providers'
import {configureChains, createConfig, WagmiConfig} from "wagmi";
import {publicProvider} from "@wagmi/core/providers/public";
import {CHAINS} from "~/utils/wallets/config";
import {connectors} from "~/utils/wallets/connections";
import {createRoot} from "react-dom/client";

function Updaters() {
  return (
    <>
      {/* <ListsUpdater/> */}
      <TransactionUpdater/>
      <MulticallUpdater/>
    </>
  )
}

function Blocklist({children}: { children: ReactNode }) {
  const {account} = useActiveWeb3React()
  const blocked: boolean = useMemo(() => Boolean(account && BLOCKED_ADDRESSES.indexOf(account) !== -1), [account])
  if (blocked) {
    return <div>Blocked address</div>
  }
  return <>{children}</>
}

const root = createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
    <Providers>
      <Blocklist>
        <div style={{overflow: "hidden"}}>
          <App/>
        </div>
        <Updaters/>
      </Blocklist>
    </Providers>
  // </React.StrictMode>
)
